import React, { Component } from 'react'
import { Column, Row } from '../components/Grid'
import { toDate, setHours, setMinutes, format } from 'date-fns'

export default class LocationType extends Component {

  /**
   *
   * @param militaryHoursString
   * @returns {string}
   */
  formatTime(militaryHoursString) {
    let result = militaryHoursString;

    if (militaryHoursString.includes(':')) {
      const time = militaryHoursString.split(':');
      const date = new Date();

      result = toDate(date);
      result = setHours(result, time[0]);
      result = setMinutes(result, time[1]);
      result = format(result, "h:mm aaaa");
    }

    return result
  }

  render() {
    const { data } = this.props
    if (!data) return null
    // console.log('location block data: ', data)

    const {
      // name,
      additionalHoursText,
      displayAddress,
      // delivery,
      description,
      email,
      // images,
      phone,
      // pickup,
      mondayOpeningTime,
      mondayClosingTime,
      // tuesdayOpeningTime,
      // tuesdayClosingTime,
      // wednesdayOpeningTime,
      // wednesdayClosingTime,
      // thursdayOpeningTime,
      // thursdayClosingTime,
      fridayOpeningTime,
      fridayClosingTime,
      mapEmbedCode,
    } = data;
    // additionalHoursText: {childMarkdownRemark: {…}}
    // address: "41 Montgomery St, San Francisco, CA 94104"
    // delivery: true
    // description: null
    // displayAddress: "41 Montgomery (@ Sutter), (Near Montgomery BART Station), San Francisco, CA 94104"
    // email: "info@eatatbamboo.com"
    // fridayClosingTime: "18:00"
    // fridayOpeningTime: "11:00"
    // images: null
    // mondayClosingTime: "19:00"
    // mondayOpeningTime: "11:00"
    // name: "41 Montgomery, St, SF (Financial District)"
    // phone: "14157729134"
    // pickup: true
    // slug: "san-francisco-financial-district"
    // thursdayClosingTime: "19:00"
    // thursdayOpeningTime: "11:00"
    // tuesdayClosingTime: "19:00"
    // tuesdayOpeningTime: "11:00"
    // wednesdayClosingTime: "19:00"
    // wednesdayOpeningTime: "11:00"


    // todo: implement checking for other days
    const mondayOpeningHours = mondayOpeningTime ? this.formatTime(mondayOpeningTime) : '';
    const mondayClosingHours = mondayClosingTime ? this.formatTime(mondayClosingTime) : '';
    const fridayOpeningHours = fridayOpeningTime ? this.formatTime(fridayOpeningTime) : '';
    const fridayClosingHours = fridayClosingTime ? this.formatTime(fridayClosingTime) : '';

    const isFridayDifferent = mondayOpeningTime !== fridayOpeningTime || mondayClosingTime !== fridayClosingTime;

    return (
      <Row>
          <Column>
            { mapEmbedCode ? <div dangerouslySetInnerHTML={ {__html: mapEmbedCode.childMarkdownRemark.html} }/> : 'Need map here' }
          </Column>
          <Column>
            <div>{displayAddress}</div>
            <br />
            { description ? <div dangerouslySetInnerHTML={ {__html: description.childMarkdownRemark.html} }/> : null }
            <br />
            { email ? <div><strong>Email</strong> <a href={`mailto:${email}`}>{email}</a></div> : null }
            { phone ? <div><strong>Phone</strong> <a href={`tel:${phone}`}>{phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3')}</a></div> : null }
            <br />
            <div><strong>Hours</strong></div>
            <div>
              Mon - {isFridayDifferent ? 'Thurs' : 'Fri' } {mondayOpeningHours} - {mondayClosingHours}<br />
              { isFridayDifferent ? <div>{`Fri ${fridayOpeningHours} - ${fridayClosingHours}`}</div> : null }
            </div>
            <br />
            { additionalHoursText ? <div dangerouslySetInnerHTML={ {__html: additionalHoursText.childMarkdownRemark.html} }/> : null }
          </Column>
      </Row>
    )
  }
}
